import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import InsertNewData from '../../../../Components/InsertNewData'
import {Spinner} from 'react-bootstrap'
import ContactListPanel from '../Components/ContactListPanel'
import {useDispatch, useSelector} from 'react-redux'
import {GetContectData} from '../AllContactsList/SubscriberSlice/SubscriberSlice'
import ContectDataModel from '../../../../Components/ContectDataModel'
import EditSingleSubscriber from '../AllContactsList/Modal/EditSingleSubscriber'
import {
  ContactGroupMap,
  ContactStatus,
  DeleteContactsParams,
  Group,
  Tag,
} from '../../../../../services/cellcast.v2.types'
import {useContact} from '../../../../hooks/useContact'
import {useGetAllTagsQuery, useLazyGetAllTagsQuery} from '../../../../../services/cellcast'
import AssignedTags from '../AllContactsList/Modal/AssignedTags'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {toast} from 'react-toastify'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import ReSubscribeListPopup from '../AllContactsList/Modal/ReSubscribeListPopup'
import {useNavigate} from 'react-router-dom'
import UploadContact from '../Components/UploadContactModal'
import ContactCountPanel from '../Components/ContactCountPanel'
import ContactDetailPanel from '../Components/ContactDetailPanel'
import {useAllTagsMutation} from '../../../../../services/cellcast.v3'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

interface UnsubscribePageProps {
  newNavigation?: boolean
  setTotal?: (value?: number) => void
}

const UnsubscribePage: FC<UnsubscribePageProps> = ({ newNavigation, setTotal }) => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const navigate = useNavigate()
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  // Api Fetching Hook
  const {loading, data, actions} = useContact('UnsubscribePage')

  // load all tag hook
  const [fetchAllTags, {isLoading: tagLoad, data: tagsData}] = useLazyGetAllTagsQuery()
  const [fetchAllTagInt, {isLoading: tagIntLoad, data: tagIntData}] = useAllTagsMutation()

  // load tag in init
  useEffect(() => {
    if (isDefaultRegion) {
      fetchAllTags(null)
    } else {
      fetchAllTagInt({
        action: 'all_tag',
        data: {},
      })
    }
  }, [isDefaultRegion])

  const getTags = useCallback(() => {
    if (isDefaultRegion) {
      return tagsData && tagsData.data ? tagsData.data.filter((el: any) => el.type !== 'list') : []
    }

    return tagIntData && tagIntData.data
      ? tagIntData.data?.filter((el: any) => el.type !== 'list')
      : []
  }, [isDefaultRegion, tagsData, tagIntData])

  // Local state
  const [reloadSubscriberCount, setReloadSubscriberCount] = useState(false)
  const [selectedContactGroupIDs, setSelectedContactGroupIDs] = useState<string[]>([])
  const [selectedContactIDs, setSelectedContactIDs] = useState<string[]>([])
  const [showAddModal, setShowAddModal] = useState(false)
  const [showReSubscribeModal, setShowReSubscribeModal] = useState(false)
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [editModal, setEditModal] = useState<{
    data: any
    toggle: boolean
    number?: string
    _id?: string
    tags: Tag[]
    group?: Group
  }>({
    data: '',
    toggle: false,
    tags: [],
  })

  const [showQmDrawer, setShowQmDrawer] = useState(false)
  const [showEditTagModal, setShowAddTagModal] = useState(false)
  const [showUnsubscribeConfirmation, setShowUnsubscribeConfirmation] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const [selectedDetailId, setSelectedDetailId] = useState('')

  // action
  const handleShowDetailModal = (number: string, contactId: string) => {
    setSelectedDetailId(contactId)
    setShowDetailModal(true)
  }

  const handleChangSizeData = (size: number) => {
    actions.setParams({...data.params, limit: size, page: ''})
    actions.setTriggerFetch()
  }

  const handleShowEditModal = (data: ContactGroupMap) => {
    const mergedArray = data && data.group && data.group.fields ? [...data.group.fields] : []

    const finalFieldData = mergedArray.map((key) => {
      if (data?.fields?.find((field) => field.name === key) !== undefined) {
        return data?.fields?.find((field) => field?.name === key)
      } else {
        return {name: key, value: ''}
      }
    })
    setEditModal({
      data: finalFieldData,
      toggle: true,
      number: data?.number,
      _id: data?._id,
      tags: data?.tags,
      group: data?.group,
    })
  }

  const handleSubscribe = useCallback(
    (contactIDs: string[]) => {
      let payload: any = {contactIDs: contactIDs}

      if (!isDefaultRegion) {
        payload = {
          is_subscribe: true,
          ids: contactIDs,
        }
      }

      actions
        .subscribe(payload)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error subscribe:', res.error)
          }
          actions.setTriggerFetch()
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
          setReloadSubscriberCount(true)
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [actions]
  )

  const handleUnsubscribe = useCallback((contactIDs: string[]) => {
    setSelectedContactIDs(contactIDs)
    setShowUnsubscribeConfirmation(true)
    setReloadSubscriberCount(true)
  }, [])

  const handleDoFetchData = useCallback((fetchGroup) => {
    if(fetchGroup){
      actions.setTriggerFetchGroup(true)
    }
    actions.setParams({...data.params, page: ''})
    actions.setTriggerFetch()
  }, [actions, data.params])

  const handleChangePage = useCallback(
    (page: number | null, next: boolean) => {
      if (page === null || loading.contactFetch || loading.contactLoad) {
        return
      }

      if (next) {
        actions.setParams({...data.params, page: page})
        actions.setTriggerFetchNext()
      } else {
        actions.setParams({...data.params, page: page})
        actions.setTriggerFetchPrev()
      }
    },
    [actions, data.params]
  )

  const handleSetSort = (sortKey: string, sortValue: string) => {
    actions.setParams({...data.params, sortKey: sortKey, sortValue: sortValue})
    actions.setTriggerFetch()
  }

  const handleExports = useCallback(() => {
    actions
      .exportContact({
        query: data.params,
        body: {
          contactIDs: selectedContactGroupIDs.length > 0 ? selectedContactGroupIDs : [],
        },
      })
      .then((res) => {
        if ('data' in res) {
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
          window.open(`${API_DOMAIN}${res.data?.data.downloadurl}`, '_self')
        } else if ('error' in res) {
          toast.error(res.error)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
          console.error('Error export:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
        setSelectedContactIDs([])
        setSelectedContactGroupIDs([])
      })
  }, [API_DOMAIN, actions, selectedContactGroupIDs])

  const handleShowBm = useCallback(() => {
    if (selectedContactGroupIDs) {
      if (selectedContactGroupIDs?.length > 0) {
        navigate(`/new-message`, {
          state: {
            selectedType: 'contacts',
            data: data.contacts
              .filter((key: ContactGroupMap) => selectedContactGroupIDs?.includes(key?._id))
              ?.map((key: any) => key?.number),
          },
        })
      } else {
        navigate(`/new-message`, {state: 'all'})
      }
    }
  }, [data.contacts, navigate, selectedContactGroupIDs])

  // Modal pop up
  const AddContact = useMemo(
    () => (
      <UploadContact
        groupId={data.group?.data?._id || undefined}
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        isUnsubscribe={true}
      />
    ),
    [showAddModal]
  )

  const UnsubScribeContact = useMemo(
    () => (
      <ReSubscribeListPopup
        show={showReSubscribeModal}
        handleClose={() => setShowReSubscribeModal(false)}
      />
    ),
    [showReSubscribeModal]
  )

  const ContactDetail = useMemo(
    () => (
      <ContactDetailPanel
        show={showDetailModal}
        handleClose={() => {
          setShowDetailModal(false)
          setSelectedDetailId('')
        }}
        setEditPopup={setEditModal}
        contactId={selectedDetailId}
        group={data?.group?.data}
      />
    ),
    [showDetailModal]
  )

  const EditContact = useMemo(
    () => (
      <EditSingleSubscriber
        show={editModal}
        handleClose={setEditModal}
        callbackFn={() => {
          actions.setTriggerFetch()
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        }}
      />
    ),
    [actions, editModal]
  )

  const SendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={showQmDrawer}
        handleClose={() => setShowQmDrawer(false)}
        contacts={
          data.contacts.length > 0
            ? data.contacts
                .filter((key: any) => selectedContactGroupIDs?.includes(key?._id))
                .map((key: any) => ({value: key?.number, label: key?.number}))
            : []
        }
      />
    ),
    [selectedContactGroupIDs, showQmDrawer]
  )

  const EditTagModal = useMemo(
    () => (
      <AssignedTags
        checkList={selectedContactGroupIDs}
        show={showEditTagModal}
        handleClose={() => setShowAddTagModal(false)}
        callbackFn={() => {
          actions.setTriggerFetch()
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        }}
      />
    ),
    [showEditTagModal, selectedContactGroupIDs]
  )

  const UnsubscribeConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={showUnsubscribeConfirmation}
        handleClose={() => {
          setShowUnsubscribeConfirmation(false)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
        }}
        Message={'Are you sure, you want to unsubscribe contact ?'}
        confirm={() => {
          if (selectedContactIDs && selectedContactIDs.length > 0) {
            let payload: any = {contactIDs: selectedContactIDs}
            if (!isDefaultRegion) {
              payload = {
                is_subscribe: false,
                ids: selectedContactIDs,
              }
            }

            actions
              .unsubscribe(payload)
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error unsubscribe:', res.error)
                }
                actions.setTriggerFetch()
                setSelectedContactIDs([])
                setSelectedContactGroupIDs([])
                setReloadSubscriberCount(true)
              })
              .catch((err) => {
                toast.error(err.error)
              })
            setShowUnsubscribeConfirmation(false)
          }
        }}
        confirmBtnTitle='Yes, unsubscribe'
      />
    ),
    [showUnsubscribeConfirmation, selectedContactIDs, actions]
  )

  const DeleteContact = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={showDeleteConfirmation}
        handleClose={() => {
          setShowDeleteConfirmation(false)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
        }}
        Message={
          selectedContactGroupIDs?.length
            ? `Are you sure, you want to delete ${
                selectedContactGroupIDs?.length
                  ? `${selectedContactGroupIDs.length} selected`
                  : 'all'
              } contact?`
            : `To confirm that you want to delete all contacts and data from your account, please type "DELETE" in the field provided below`
        }
        confirm={() => {
          let params: any = {
            query: data.params,
            body: {
              contactIDs: selectedContactGroupIDs,
              allContact: false,
            },
          }

          let isUseFilter = false
          if (!isUseFilter && data.params.tag && data.params.tag.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.excludeTag && data.params.excludeTag.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.search && data.params.search.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.status && data.params.status.length > 0) {
            isUseFilter = true
          }

          if (isUseFilter === false && selectedContactGroupIDs.length === 0) {
            params.body.allContact = true
          }

          if (!isDefaultRegion) {
            params = {
              ids: selectedContactGroupIDs,
            }

            if (!selectedContactGroupIDs?.length) {
              params['is_delete_all'] = true
            }
          }

          actions
            .deleteContact(params)
            .then((res) => {
              if ('data' in res) {
                toast.success(res.data?.message)
              } else if ('error' in res) {
                toast.error(res.error)
                console.error('Error delete contact:', res.error)
              }
              actions.setTriggerFetch()
              setSelectedContactIDs([])
              setSelectedContactGroupIDs([])
            })
            .catch((err) => {
              toast.error(err.error)
            })
        }}
        subTitle={'These contacts and all data will be permanently deleted from your account.'}
        withInputConfirmation={selectedContactGroupIDs.length < 1}
      />
    ),
    [actions, data.group, selectedContactGroupIDs, showDeleteConfirmation]
  )

  // effect
  useEffect(() => {
    if (
      data.params &&
      (!data.params.status ||
        (data.params.status && data.params.status !== ContactStatus.unsubscribe))
    ) {
      actions.setParams({
        ...data.params,
        status: ContactStatus.unsubscribe,
      })
    }
  }, [data.params])

  useEffect(() => {
      if (setTotal && data.totalContacts !== undefined) {
        setTotal(data.totalContacts ?? 0)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.totalContacts])

  return (
    <>
      {AddContact}
      {UnsubScribeContact}
      {ContactDetail}
      {EditContact}
      {UnsubscribeConfirmation}
      {DeleteContact}
      {SendQuickMessage}
      {EditTagModal}
      {/* handle group data  */}
      {!loading.groupLoad &&
        (!data.group || !data.group.data || (data.group && !data.group.data._id)) && (
          <InsertNewData
            message={{
              title: `You don't have any contacts yet`,
              subtitle: `Easily add your contacts by uploading your list or add your contacts by copying and pasting`,
            }}
            buttonName={{
              name: 'Add contacts',
              link: '',
              popup: true,
              buttonFun: () => setShowAddModal(true),
            }}
          />
        )}
      {(loading.groupLoad || tagLoad) && (
        <div className='row flex-center h-200'>
          <Spinner />
        </div>
      )}

      {!loading.groupLoad && !tagLoad && data.group && data.group.data && data.group.data._id && (
        <>
          {!newNavigation ? (
            <ContactCountPanel
              reloadSubscriberCount={reloadSubscriberCount}
              setReloadSubscriberCount={setReloadSubscriberCount}
              params={data.params}
              setParams={actions.setParams}
              setTriggerFetch={actions.setTriggerFetch}
              showAllCount={false}
              showSubscriberCount={false}
            />
          ) : null }
          <ContactListPanel
            groupId={data.group && data.group.data ? data.group.data._id : ''}
            contacts={data.contacts}
            groupField={
              data.group && data.group.data && data.group.data.fields ? data.group.data.fields : []
            }
            totalData={data.totalContacts}
            loadedData={data.loadedContact}
            params={data.params}
            setParams={actions.setParams}
            isFetchLoading={loading.contactFetch}
            isLoading={loading.contactLoad}
            isCountLoading={loading.contactCountLoading}
            isFetchCountLoading={loading.contactCountFetching}
            isLoadingExport={loading.export}
            next={data.next}
            prev={data.prev}
            tags={getTags()}
            doFetchData={handleDoFetchData}
            handleShowDetailContact={handleShowDetailModal}
            handleChangSizeData={handleChangSizeData}
            handleShowEditContact={handleShowEditModal}
            handleDelete={() => setShowDeleteConfirmation(true)}
            handleExport={() => handleExports()}
            handleShowAddContactModal={setShowAddModal}
            handleShowReSubscribeContactModal={setShowReSubscribeModal}
            handleShowAttachTagModal={setShowAddTagModal}
            handleShowQmDrawer={setShowQmDrawer}
            handleShowBm={handleShowBm}
            handleSubscribe={handleSubscribe}
            handleUnsubscribe={handleUnsubscribe}
            selectedContactIDs={selectedContactIDs}
            setSelectedContactIDs={setSelectedContactIDs}
            handleChangePage={handleChangePage}
            handleSetSort={handleSetSort}
            isLoadingSubAndUnSub={loading.unsubscribe || loading.subscribe}
            selectedContactGroupIDs={selectedContactGroupIDs}
            setSelectedContactGroupIDs={setSelectedContactGroupIDs}
            showFilterStatus={false}
            showSendMessageAction={false}
            showSubscribeStatus={false}
            showExport={isDefaultRegion ? true : false}
            showAddTag={isDefaultRegion ? true : false}
            showFilterField={isDefaultRegion ? true : false}
          />
        </>
      )}
    </>
  )
}

export default UnsubscribePage
